<template>
  <Card title="Query Results" :error="error" errorTitle="Query Fialed" no-body>
    <!-- <div v&#45;if="!dataMatchesCurrentRead"> -->
    <template #header-suffix>
      <Button
        v-if="hasData"
        @click="reset"
        tooltip-position="left"
        tooltip="If too many objects are loaded the page might be slow"
      >
        Reset
      </Button>
    </template>
    <b-alert
      v-show="hasData && !dataMatchesCurrentRead"
      show
      variant="warning"
      class="m-3"
    >
      <pre class="pre-wrap m-0">
        The data displayed was run from a different query than the current one
      </pre>
    </b-alert>
    <!-- </div> -->
    <b-table-lite
      v-if="hasData"
      striped
      hover
      bordered
      small
      responsive
      :items="data"
      :fields="fields"
      class="mb-0"
    />
    <b-card-body v-if="!hasData && !error" class="no-read-data">
      <b-spinner v-if="loading" />
      <span v-else>
        No data. Please run a query to see read data.
      </span>
    </b-card-body>
  </Card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState, mapGetters } from 'vuex';

import store from '@/plugins/vuex';
import Card from '@/components/Card.vue';
import Button from '@/components/Button.vue';

export default defineComponent({
  name: 'QueryResult',
  components: {
    Button,
    Card,
  },
  // data() {
  //   return {
  //     loading: true,
  //   };
  // },
  computed: {
    ...mapState({
      loading: (state: any) => state.read.loading,
      error: (state: any) => state.read.error,
      hasData: (state: any) => state.read.data?.length,
      dataQuery: (state: any) => state.read.dataOptions?.query,
    }),
    ...mapGetters({
      data: 'read/flatReadResult',
      dataMatchesCurrentRead: 'read/dataMatchesCurrentRead',
    }),
    fields() {
      // To avoid startCase on table headers
      if (!this.data?.length) {
        return null;
      }

      return Object.keys(this.data[0]).map(f => {
        return {
          key: f,
          label: f,
          headerTitle: f,
          // formatter: (value, key, item) => {
          //   // console.log('formatting');
          //   // console.log('formatterin', value, key, item);
          //   return value;
          // },
        };
      });
    },
  },
  methods: {
    ...mapActions({
      reset: 'read/resetReadResult',
    }),
  },
});
</script>
<style scoped>
.no-read-data {
  display: flex;
  justify-content: center;
}
</style>
